import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Dut({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header={t("dut")} visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="dutPanel">
            <Trans i18nKey="dutDetails" />

            <h2 className="text-center titles text-bluegray-400">{t("skills")}</h2>

            <p className="text-center"><Trans i18nKey="dutSkills" /></p>
        </Dialog>
    )
}